/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { AttributesFormModel } from '../data/models';

export const getFieldsConfig = (
  itemValues: Record<string, any>,
  attributesFormList: AttributesFormModel[]
) => {
  return attributesFormList?.map((field) => {
    const newItemValues = {
      ...itemValues,
      firstName: itemValues.firstname ?? itemValues.firstName,
      lastName: itemValues.lastname ?? itemValues.lastName,
      middleName: itemValues.middlename ?? itemValues.middleName,
    };
    const newField = JSON.parse(JSON.stringify(field));

    if (Object.hasOwn(newItemValues, field.customUpperCode)) {
      const value =
        newItemValues[field.customUpperCode as keyof typeof newItemValues];

      if (field.customUpperCode === 'region' && typeof value === 'object') {
        newField.defaultValue =
          value.regionCode && value.regionId
            ? `${value.regionCode},${value.regionId}`
            : value.region ?? value.regionCode;
      } else {
        newField.defaultValue = value;
      }
    }

    return newField;
  });
};
